import React, { useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from "prop-types";
import { P2Alert } from '../../P2Alert'
import { P2TextLabel } from './../../P2Text'

const P2TextInput = React.forwardRef(({...props},ref) => {
  const [holdingText, setHoldingText] = useState(props.value ? props.value : '');
  const textInputRef = useRef(null);

  
  const [isDirty, setDirty] = useState(false);
  const [isFocus, setFocus] = useState(false);
  const [isBlur, setBlur] = useState(true);
  
  const [ showError, setShowError ] = useState(false);

  useEffect(()=>{
    let timeoutID;
      timeoutID = window.setTimeout(()=>{
        if(props.forceError){
          setShowError(true);
        }
        else{
          if(isDirty && !isFocus && isBlur){
            setShowError(true);
          }
          else{
            setShowError(false);          
          }
        }
      },200);
    return () =>{
      clearTimeout(timeoutID);
    }
  },[isDirty, isFocus, isBlur, props.forceError])

  useImperativeHandle(ref, () => {
    return {
      clearHoldingText(){
        setHoldingText('');
      }
    };
  }, [isDirty, holdingText]);

  return (
    <div className='polymer-textinput-form'>
      {props.label && <P2TextLabel for={props.name} marginBottom='10px' label={props.label} required={props.required} hasTooltip={props.hasTooltip} tooltipContent={props.tooltipContent}/>}
      <div className='polymer-textinput-form__textinput-container' style={{ gap: props.variant === "button" ? '1.5rem' : '0'}}>
        <div style={{flex:1}}>
          <input id={props.name} style={{borderColor: isBlur && props?.value?.length > 0 ? "#575757" : "", backgroundColor: isBlur && props?.value?.length > 0 ? "#F7F7F7" : ""}} name={props.name} readOnly={props.readOnly} autoComplete={props.autoComplete ? "on" : "off"} required={props.required} minLength={props.minLength} maxLength={props.maxLength} onFocus={()=>{
            setFocus(true);
            setBlur(false);
          }} 
          onClick={() => {
            props?.onClick?.();
          }}
          ref={textInputRef} type={props.type} disabled={props.disabled} aria-disabled={props.disabled} value={props.variant === "button" ? holdingText : props.value} placeholder={props.placeholder} onChange={(e)=>{
            //handleChange(e);
            const { value } = e.target;
            if(value !== "")
            {
              setDirty(true);
            }
            
            if(props.pattern){
              let regex = new RegExp(props.pattern);///^[2A-Za-z]+$/; 
              if(value === "" || regex.test(value)){
                if(props.onChange && props.variant !== "button"){
                  props.onChange(value);
                }
                else{
                  setHoldingText(value);
                }
              }
            }
            else{
              if(props.onChange && props.variant !== "button"){
                props.onChange(value);
              }
              else{
                setHoldingText(value);
              }
            }

          }}
          
          onBlur={(e)=>{
            setBlur(true);
            setFocus(false);
            if(props.onBlur){
              const { value } = e.target;
              props.onBlur(value);
            }
          }} 

          />
          <span style={{position: 'relative', top: "-36px", left: "calc(100% - 2rem)", cursor: "pointer"}}>{props.icon && props.icon}</span>
        </div>
        {props.variant === "button" && <div className='polymer-textinput-form__button-container' style={{flex:0}}>
          <button onClick={()=>{
            if(props.onButtonPress){
              props.onButtonPress(holdingText);
            }
          }} type="button" className="btn btn-secondary">
            <div className='polymer-textinput-form__button-container-content'>
              <p>{!props.isLoading ? props.buttonLabel : "Checking"}</p>
              <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 8.75V33.25" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.75 21H33.25" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="21" cy="21" r="21" transform="rotate(-180 21 21)" />
              </svg>
            </div>
          </button>
        </div>}
      </div>
      { props.isError && showError && 
      <div style={{ marginTop: 10 }}>
        <p className='m-0 polymer-fields-error-message' style={{color:'#CB2A0C'}}>{props.errorMsg}</p>
      </div>
      }
    </div>
  )
})

export default P2TextInput


P2TextInput.propTypes = {
  variant: PropTypes.oneOf(['default', 'button']),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  buttonLabel: PropTypes.string,
  onButtonPress: PropTypes.func,
  onClick: PropTypes.func,
  pattern: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  hasTooltip: PropTypes.bool,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  errorMsg: PropTypes.string,
  isError: PropTypes.bool,
  onBlur: PropTypes.func,
  isLoading: PropTypes.bool,
  autoComplete: PropTypes.bool,
  icon: PropTypes.element,
  readOnly: PropTypes.bool,
  forceError: PropTypes.bool
}


P2TextInput.defaultProps = {
  variant:'default',
  required:false,
  disabled:false,
  hasTooltip:false,
  isError:false,
  isLoading:false,
  autoComplete: true,
  readOnly: false,
  forceError:false,
  tooltipContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};